var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('w-button',{attrs:{"data-test":"removeStickerButton","icon":_vm.iconStickerRemoved,"size":_vm.size,"color":_vm.color},on:{"click":_vm.removeStickerLayout}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }